export const eventForm = (state) => {
    return state.eventForm
}
export const event = (state) => {
    return state.event
}
export const myEvents = (state) => {
    return state.myEvents
}
export const isUpdatedEvent = (state) => {
    return state.isUpdatedEvent
}